import {
  View,
  Text,
  Dimensions,
  TouchableOpacity,
  Platform,
  ScrollView,
} from "react-native";
import React, { useEffect, useState } from "react";
import Modal from "react-native-modal";

import { useDispatch, useSelector } from "react-redux";
import { Feather } from "@expo/vector-icons";
import MyModal from "./MyModal";
import MyInputWithLabel from "../custom/MyInputWithLabel";
import MyText from "../custom/MyText";
import translate from "../../functions/translate";
import MyButton from "../custom/MyButton";
import StepSlide from "../animation/StepSlide";
import { danger, orange, primary } from "../../colors";
import CodeInput from "../custom/CodeInput";
import { noModal, setNoMoneyModal } from "../../redux/modal/modalAction";
import userActivation from "../../api/post/userActivation";
import { addToken } from "../../redux/main/mainAction";
import { storeStringData } from "../../functions/db/db";
import { useNavigation } from "@react-navigation/native";
import addSignupGift from "../../api/wallet/addSignupGift";
import { height, width } from "../../imports";
import { currencyFormat } from "../../functions/functions";
import Fade from "../animation/Fade";
import buyTutorial from "../../api/tutorial/buyTutorial";

export default function BuyTutorial({
  pdfName,
  open,
  onClose,
  store,
  id,
  setConfirmed,
  temporaryToken,
  otp,
  setRefreshing,
}) {
  const [code, setCode] = useState(null);
  const modal = useSelector((store) => store.modal);
  const dispatch = useDispatch();
  const [changed, setChanged] = useState(false);
  const navigation = useNavigation();
  const [mode, setMode] = useState(1);

  const buttonClicked = () => {
    if (mode === 1) {
      setMode(2);
    } else {
      buyTutorial(store.id, "IR").then(({ data }) => {
        if (data.status === 106) {
          dispatch(setNoMoneyModal());
        } else if (data.status === 200) {
          setRefreshing((prev) => !prev);
          onClose();
        } else {
          Toast.show({
            type: "error",
            text1: data.description.fa,
          });
        }
      });
      setMode(1);
    }
  };

  return (
    <Modal
      isVisible={open}
      style={{ zIndex: 1000, justifyContent: "center", alignContent: "center" }}
      onBackdropPress={() => onClose()}
    >
      <View>
        <View
          style={{
            width: "100%",
            backgroundColor: "#fefefe",
            padding: 10,
            borderRadius: 10,
            minHeight: 200,
          }}
        >
          <View style={{ flexDirection: "row" }}>
            <TouchableOpacity onPress={() => onClose()}>
              <Feather name="x" size={24} color={danger} />
            </TouchableOpacity>
            <MyText style={{ marginHorizontal: 10 }}>{pdfName}</MyText>
          </View>
          <View>
            <View
              style={{
                width: "100%",
                alignItems: "center",
              }}
            >
              <MyText>ابتدا باید این آموزش را خریداری کنید</MyText>

              <MyText></MyText>
              <MyText>
                {`با تایید خرید مبلغ ${currencyFormat(
                  store?.priceOffer !== 0 ? store?.priceOffer : store.price
                )} تومان از حساب شما کسر خواهد شد`}
              </MyText>
              <MyText></MyText>
              <Fade isShown={mode === 1} duration={200}>
                <MyButton
                  onPress={buttonClicked}
                  style={{ width: "100%" }}
                  text={`خرید آموزش`}
                />
              </Fade>
              <Fade isShown={mode === 2} duration={200}>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <View style={{ flex: 2 }}>
                    <MyButton
                      textStyle={{ fontSize: 12 }}
                      onPress={() => setMode(1)}
                      style={{
                        backgroundColor: danger,
                        paddingHorizontal: 0,
                        marginHorizontal: 2,
                      }}
                      text={`لغو`}
                    />
                  </View>
                  <View style={{ flex: 4 }}>
                    <MyButton
                      textStyle={{ fontSize: 13 }}
                      style={{ paddingHorizontal: 0, marginHorizontal: 2 }}
                      onPress={buttonClicked}
                      text={`تایید`}
                    />
                  </View>
                </View>
              </Fade>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
}
